import "@/App.css";

const LOGOTYPE_URL =
  "https://customer-assets.emergentagent.com/job_quick-launch-142/artifacts/edoqw702_The_Heir_LogoType.jpg";
const WAVE_URL =
  "https://customer-assets.emergentagent.com/job_quick-launch-142/artifacts/wwi1oy60_AdobeStock_564578858.png";

const Home = () => {
  const year = new Date().getFullYear();

  return (
    <main
      className="heir-page"
      role="main"
      data-testid="heir-holding-page"
    >
      {/* Crop-mark corner ticks */}
      <div className="heir-ticks" aria-hidden="true" data-testid="heir-ticks">
        <span className="tl" />
        <span className="tr" />
        <span className="bl" />
        <span className="br" />
      </div>

      {/* Stage: marque + logotype + strapline */}
      <section
        className="heir-stage"
        aria-label="The Heir Group"
        data-testid="heir-stage"
      >
        <svg
          className="heir-marque"
          viewBox="0 0 40 120"
          xmlns="http://www.w3.org/2000/svg"
          role="img"
          aria-label="The Heir Group marque — four dots stacked vertically"
          data-testid="heir-marque"
        >
          <circle cx="20" cy="15" r="7" fill="#BFA882" />
          <circle cx="20" cy="45" r="7" fill="#BFA882" />
          <circle cx="20" cy="75" r="7" fill="#F5F1E9" />
          <circle cx="20" cy="105" r="7" fill="#BFA882" />
        </svg>

        <div className="heir-logo-wrap">
          <img
            className="heir-logotype"
            src={LOGOTYPE_URL}
            alt="The Heir."
            width="2490"
            height="340"
            draggable="false"
            data-testid="heir-logotype"
          />

          <div className="heir-strapline" data-testid="heir-strapline">
            <span className="heir-rule" aria-hidden="true" />
            <p className="heir-strapline-text">
              A confidential strategic advisory.
              <span className="dot-sep">·</span>
              By appointment.
            </p>
          </div>
        </div>
      </section>

      {/* Edge-to-edge gold wave band */}
      <div
        className="heir-wave-band"
        aria-hidden="true"
        data-testid="heir-wave-band"
      >
        <img className="heir-wave" src={WAVE_URL} alt="" draggable="false" />
      </div>

      {/* Footer */}
      <footer className="heir-footer" data-testid="heir-footer">
        <span className="heir-footer-left">The Heir Group</span>
        <span className="heir-footer-center">Private · Discreet · Trusted</span>
        <span className="heir-footer-right">© {year}</span>
      </footer>
    </main>
  );
};

function App() {
  return <Home />;
}

export default App;
